// Siteconfig object is not available while testing with jest
const siteConfigAsJSON = document.getElementById("site_config")?.textContent;
export const siteConfig = JSON.parse(siteConfigAsJSON ? siteConfigAsJSON : "{}");

export default siteConfig;
